import React from "react";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import {withTranslation} from "react-i18next";
import AlertDialog from "../alert-dialog";

const GeometriesWarningDialog = ({t, isOpen, onClose}) => (
  <AlertDialog open={isOpen} onClose={onClose}>
    <DialogContent onClose={onClose}>{t("components.map.dialogs.noGeometry.title")}</DialogContent>
    <DialogActions>
      <Button onClick={onClose}>{t("commons.confirm.close")}</Button>
    </DialogActions>
  </AlertDialog>
);

export default withTranslation()(GeometriesWarningDialog);
